import { calculateLineItemTotalInCents } from '@/features/invoices'

export type TotalsLine = { kWh?: number; tariffPerKWh?: number }

export function calcCreditNoteTotals(lines: TotalsLine[], vatPercentage: number) {
  const subTotalCents = lines.reduce(
    (total, { kWh, tariffPerKWh }) => total + calculateLineItemTotalInCents(kWh ?? 0, (tariffPerKWh ?? 0) * 100),
    0
  )
  const vatCents = Math.round(subTotalCents * (vatPercentage / 100))
  return {
    subTotalCents,
    vatCents,
    totalCents: subTotalCents + vatCents
  }
}
